// Mock data for GeoStays - Airbnb Clone

export const categories = [
  { id: 1, name: 'Amazing views', iconName: 'Mountain' },
  { id: 2, name: 'Beachfront', iconName: 'Waves' },
  { id: 3, name: 'Rural Homestay', iconName: 'Wheat' },
  { id: 4, name: 'Lakefront', iconName: 'CloudSun' },
  { id: 5, name: 'Mountains', iconName: 'MountainSnow' },
  { id: 6, name: 'Tropical', iconName: 'Palmtree' },
  { id: 7, name: 'Farms', iconName: 'Tractor' },
  { id: 8, name: 'Tiny homes', iconName: 'Home' },
  { id: 9, name: 'Treehouses', iconName: 'Trees' },
  { id: 10, name: 'Historic homes', iconName: 'Castle' }
];

export const properties = [
  {
    id: 1,
    title: 'Cozy Mountain Retreat with Stunning Valley Views',
    type: 'Entire home',
    location: 'Manali, Himachal Pradesh',
    country: 'India',
    guests: 6,
    bedrooms: 3,
    beds: 4,
    bathrooms: 2,
    price: 4500,
    rating: 4.92,
    reviews: 128,
    images: [
      'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800',
      'https://images.unsplash.com/photo-1510798831971-661eb04b3739?w=800',
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800',
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800'
    ],
    category: 'Mountains',
    amenities: ['WiFi', 'Kitchen', 'Free parking', 'Mountain view', 'Fireplace', 'Heating'],
    description: 'Escape to this charming mountain retreat nestled in the Himalayas. Perfect for families and groups seeking tranquility and breathtaking views.',
    host: {
      name: 'Rajesh Kumar',
      image: 'https://i.pravatar.cc/150?img=12',
      joinedYear: 2019,
      isSuperhost: true
    },
    instantBook: true
  },
  {
    id: 2,
    title: 'Beachfront Villa with Private Pool',
    type: 'Entire villa',
    location: 'Goa',
    country: 'India',
    guests: 8,
    bedrooms: 4,
    beds: 5,
    bathrooms: 3,
    price: 8500,
    rating: 4.88,
    reviews: 94,
    images: [
      'https://images.unsplash.com/photo-1602343168117-bb8ffe3e2e9f?w=800',
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800',
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800',
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800'
    ],
    category: 'Beachfront',
    amenities: ['Pool', 'Beach access', 'WiFi', 'Kitchen', 'Air conditioning', 'BBQ grill'],
    description: 'Luxurious beachfront villa with direct beach access and stunning ocean views. Perfect for a tropical getaway with family and friends.',
    host: {
      name: 'Priya Sharma',
      image: 'https://i.pravatar.cc/150?img=5',
      joinedYear: 2018,
      isSuperhost: true
    },
    instantBook: true
  },
  {
    id: 3,
    title: 'Rustic Farmhouse in the Countryside',
    type: 'Entire home',
    location: 'Pune, Maharashtra',
    country: 'India',
    guests: 5,
    bedrooms: 2,
    beds: 3,
    bathrooms: 2,
    price: 3200,
    rating: 4.95,
    reviews: 156,
    images: [
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800',
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800',
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800',
      'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800'
    ],
    category: 'Farms',
    amenities: ['Garden', 'Free parking', 'Kitchen', 'Pet friendly', 'Farm activities', 'Outdoor dining'],
    description: 'Experience authentic rural life in this charming farmhouse surrounded by lush greenery and organic farms.',
    host: {
      name: 'Amit Patel',
      image: 'https://i.pravatar.cc/150?img=33',
      joinedYear: 2020,
      isSuperhost: false
    },
    instantBook: false
  },
  {
    id: 4,
    title: 'Lakeside Cottage with Boat Access',
    type: 'Entire cottage',
    location: 'Nainital, Uttarakhand',
    country: 'India',
    guests: 4,
    bedrooms: 2,
    beds: 2,
    bathrooms: 1,
    price: 3800,
    rating: 4.91,
    reviews: 87,
    images: [
      'https://images.unsplash.com/photo-1499696010180-025ef6e1a8f9?w=800',
      'https://images.unsplash.com/photo-1542718610-a1d656d1884c?w=800',
      'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800',
      'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800',
      'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800'
    ],
    category: 'Lakefront',
    amenities: ['Lake view', 'Boat included', 'WiFi', 'Kitchen', 'Fishing equipment', 'Deck'],
    description: 'Peaceful lakeside retreat perfect for nature lovers. Enjoy morning mist, boating, and stunning sunsets.',
    host: {
      name: 'Sneha Reddy',
      image: 'https://i.pravatar.cc/150?img=9',
      joinedYear: 2019,
      isSuperhost: true
    },
    instantBook: true
  },
  {
    id: 5,
    title: 'Tropical Paradise with Ocean Views',
    type: 'Entire bungalow',
    location: 'Andaman Islands',
    country: 'India',
    guests: 6,
    bedrooms: 3,
    beds: 4,
    bathrooms: 2,
    price: 7200,
    rating: 4.97,
    reviews: 203,
    images: [
      'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800',
      'https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=800',
      'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=800',
      'https://images.unsplash.com/photo-1615571022219-eb45cf7faa9d?w=800',
      'https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?w=800'
    ],
    category: 'Tropical',
    amenities: ['Ocean view', 'Beach access', 'WiFi', 'Air conditioning', 'Snorkeling gear', 'Outdoor shower'],
    description: 'Your own slice of paradise! Wake up to turquoise waters and white sandy beaches. Perfect for a romantic getaway or family vacation.',
    host: {
      name: 'Vikram Singh',
      image: 'https://i.pravatar.cc/150?img=15',
      joinedYear: 2017,
      isSuperhost: true
    },
    instantBook: true
  },
  {
    id: 6,
    title: 'Charming Treehouse in the Forest',
    type: 'Treehouse',
    location: 'Coorg, Karnataka',
    country: 'India',
    guests: 2,
    bedrooms: 1,
    beds: 1,
    bathrooms: 1,
    price: 2800,
    rating: 4.93,
    reviews: 167,
    images: [
      'https://images.unsplash.com/photo-1618767689160-da3fb810aad7?w=800',
      'https://images.unsplash.com/photo-1587061949409-02df41d5e562?w=800',
      'https://images.unsplash.com/photo-1542718610-a1d656d1884c?w=800',
      'https://images.unsplash.com/photo-1501183638710-841dd1904471?w=800',
      'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800'
    ],
    category: 'Treehouses',
    amenities: ['Forest view', 'Bird watching', 'WiFi', 'Breakfast included', 'Nature trails', 'Private deck'],
    description: 'Experience nature from above in this romantic treehouse. Perfect for couples seeking a unique adventure.',
    host: {
      name: 'Maya Iyer',
      image: 'https://i.pravatar.cc/150?img=20',
      joinedYear: 2020,
      isSuperhost: false
    },
    instantBook: false
  },
  {
    id: 7,
    title: 'Modern Tiny Home with Smart Design',
    type: 'Tiny home',
    location: 'Bangalore, Karnataka',
    country: 'India',
    guests: 2,
    bedrooms: 1,
    beds: 1,
    bathrooms: 1,
    price: 2200,
    rating: 4.89,
    reviews: 142,
    images: [
      'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?w=800',
      'https://images.unsplash.com/photo-1578645510447-e20b4311e3ce?w=800',
      'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800',
      'https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=800',
      'https://images.unsplash.com/photo-1556020685-ae41abfc9365?w=800'
    ],
    category: 'Tiny homes',
    amenities: ['WiFi', 'Kitchen', 'Smart home', 'Workspace', 'Air conditioning', 'Minimalist design'],
    description: 'Compact luxury! This thoughtfully designed tiny home proves less is more. Perfect for digital nomads and minimalists.',
    host: {
      name: 'Arjun Mehta',
      image: 'https://i.pravatar.cc/150?img=8',
      joinedYear: 2021,
      isSuperhost: false
    },
    instantBook: true
  },
  {
    id: 8,
    title: 'Heritage Haveli with Royal Architecture',
    type: 'Heritage home',
    location: 'Jaipur, Rajasthan',
    country: 'India',
    guests: 10,
    bedrooms: 5,
    beds: 7,
    bathrooms: 4,
    price: 12000,
    rating: 4.96,
    reviews: 89,
    images: [
      'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800',
      'https://images.unsplash.com/photo-1609766857041-ed402ea8069a?w=800',
      'https://images.unsplash.com/photo-1615880484746-a134be9a6ecf?w=800',
      'https://images.unsplash.com/photo-1600011689032-8b628b8a8747?w=800',
      'https://images.unsplash.com/photo-1609766498180-c0e208e06a80?w=800'
    ],
    category: 'Historic homes',
    amenities: ['Historic', 'Traditional decor', 'Courtyard', 'WiFi', 'Cultural activities', 'Rooftop terrace'],
    description: 'Step back in time in this beautifully restored 200-year-old haveli. Experience royal Rajasthani hospitality and architecture.',
    host: {
      name: 'Maharaj Singh',
      image: 'https://i.pravatar.cc/150?img=52',
      joinedYear: 2016,
      isSuperhost: true
    },
    instantBook: false
  }
];

export const reviews = [
  {
    id: 1,
    propertyId: 1,
    userName: 'Sarah Johnson',
    userImage: 'https://i.pravatar.cc/150?img=1',
    rating: 5,
    date: 'March 2025',
    comment: 'Absolutely stunning views! The house was even better than the photos. Rajesh was an excellent host and very responsive. Would definitely come back!'
  },
  {
    id: 2,
    propertyId: 1,
    userName: 'Michael Chen',
    userImage: 'https://i.pravatar.cc/150?img=13',
    rating: 5,
    date: 'February 2025',
    comment: 'Perfect mountain getaway. The fireplace was amazing during cold evenings. Great location for hiking and exploring nearby villages.'
  },
  {
    id: 3,
    propertyId: 1,
    userName: 'Emma Wilson',
    userImage: 'https://i.pravatar.cc/150?img=45',
    rating: 4,
    date: 'January 2025',
    comment: 'Beautiful property with great amenities. Only minor issue was the WiFi speed, but the incredible views more than made up for it!'
  }
];

export const amenitiesList = [
  { icon: 'Wifi', name: 'WiFi', category: 'essentials' },
  { icon: 'ChefHat', name: 'Kitchen', category: 'essentials' },
  { icon: 'Snowflake', name: 'Air conditioning', category: 'essentials' },
  { icon: 'Flame', name: 'Heating', category: 'essentials' },
  { icon: 'Tv', name: 'TV', category: 'entertainment' },
  { icon: 'Car', name: 'Free parking', category: 'essentials' },
  { icon: 'Waves', name: 'Pool', category: 'features' },
  { icon: 'Flame', name: 'Fireplace', category: 'features' },
  { icon: 'Waves', name: 'Beach access', category: 'location' },
  { icon: 'Mountain', name: 'Mountain view', category: 'location' },
  { icon: 'Waves', name: 'Ocean view', category: 'location' },
  { icon: 'CloudSun', name: 'Lake view', category: 'location' },
  { icon: 'WashingMachine', name: 'Washer', category: 'essentials' },
  { icon: 'Wind', name: 'Dryer', category: 'essentials' },
  { icon: 'Briefcase', name: 'Workspace', category: 'essentials' },
  { icon: 'Dog', name: 'Pet friendly', category: 'policies' },
  { icon: 'UtensilsCrossed', name: 'BBQ grill', category: 'features' }
];